export const GET_LISTINGS_CACHE_KEY = 'getListings';
